import { useState } from "react";

const ViewMoreText = ({ text, maxLength }) => {
  const [expanded, setExpanded] = useState(false);

  const needsTruncation = text.length > maxLength;
  const displayText =
    expanded || !needsTruncation ? text : text.substring(0, maxLength) + "...";

  return (
    <div>
      <span style={{ textWrap: "wrap" }}>{displayText}</span>
      {needsTruncation && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a
          style={{ color: "var(--primary-background-darker)" }}
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? "...View Less" : "View More"}
        </a>
      )}
    </div>
  );
};

export default ViewMoreText;
